var _g, _path, _g2, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5 51C41.8218 51 51 41.8218 51 30.5C51 19.1782 41.8218 10 30.5 10C19.1782 10 10 19.1782 10 30.5C10 41.8218 19.1782 51 30.5 51Z",
    fill: "#606060"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 15,
    width: 31,
    height: 31
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46 30.5C46 21.9396 39.0604 15 30.5 15C21.9396 15 15 21.9396 15 30.5C15 39.0604 21.9396 46 30.5 46C39.0604 46 46 39.0604 46 30.5Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 15H46V46H15V15Z",
    fill: "#DFD7D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.097 15H15V15.0969H15.097V15Z",
    fill: "#E1D7D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.281 35.3438H23.719V36.3125H37.281V35.3438ZM37.281 36.3125H23.719V37.2812H37.281V36.3125ZM37.281 37.2812H23.719V38.25H37.281V37.2812ZM37.281 38.25H23.719V39.2188H37.281V38.25ZM25.656 39.2188H23.719V40.1875H25.656V39.2188ZM37.281 39.2188H26.625V40.1875H37.281V39.2188ZM25.656 40.1875H23.719V41.1562H25.656V40.1875ZM37.281 40.1875H26.625V41.1562H37.281V40.1875ZM25.656 41.1562H23.719V42.125H25.656V41.1562ZM37.281 41.1562H26.625V42.125H37.281V41.1562ZM25.656 42.125H23.719V43.0938H25.656V42.125ZM37.281 42.125H26.625V43.0938H37.281V42.125ZM25.656 43.0938H23.719V44.0625H25.656V43.0938ZM37.281 43.0938H26.625V44.0625H37.281V43.0938ZM25.656 44.0625H23.719V45.0312H25.656V44.0625ZM37.281 44.0625H26.625V45.0312H37.281V44.0625ZM25.656 45.0312H23.719V46H25.656V45.0312ZM37.281 45.0312H26.625V46H37.281V45.0312Z",
    fill: "#9F21A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.406 38.25H32.438V39.2188H33.406V38.25ZM31.469 39.2188H28.562V40.1875H31.469V39.2188Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.438 39.2188H31.469V40.1875H32.438V39.2188Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.406 39.2188H32.438V40.1875H33.406V39.2188Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.375 39.2188H33.406V40.1875H34.375V39.2188Z",
    fill: "#F38B7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.562 40.1875H27.594V41.1562H28.562V40.1875ZM30.5 40.1875H29.531V41.1562H30.5V40.1875Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.469 40.1875H30.5V41.1562H31.469V40.1875Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.406 40.1875H31.469V41.1562H33.406V40.1875ZM28.562 41.1562H27.594V42.125H28.562V41.1562ZM30.5 41.1562H29.531V42.125H30.5V41.1562Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.438 41.1562H30.5V42.125H32.438V41.1562Z",
    fill: "#F38B7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.406 41.1562H32.438V42.125H33.406V41.1562ZM30.5 42.125H29.531V43.0938H30.5V42.125ZM33.406 42.125H32.438V43.0938H33.406V42.125Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.562 17.9062H27.594V18.875H28.562V17.9062ZM32.438 17.9062H29.531V18.875H32.438V17.9062ZM33.406 18.875H26.625V19.8438H33.406V18.875ZM33.406 19.8438H25.656V20.8125H33.406V19.8438Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.625 20.8125H24.688V21.7812H26.625V20.8125Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.406 20.8125H26.625V21.7812H33.406V20.8125Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.312 20.8125H33.406V21.7812H36.312V20.8125ZM29.531 21.7812H23.719V22.75H29.531V21.7812Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.406 21.7812H29.531V22.75H33.406V21.7812Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.281 21.7812H33.406V22.75H37.281V21.7812ZM32.438 22.75H23.719V23.7188H32.438V22.75Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.406 22.75H32.438V23.7188H33.406V22.75Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.281 22.75H33.406V23.7188H37.281V22.75ZM38.25 23.7188H22.75V24.6875H38.25V23.7188ZM38.25 24.6875H22.75V25.6562H38.25V24.6875ZM38.25 25.6562H22.75V26.625H38.25V25.6562ZM38.25 26.625H22.75V27.5938H38.25V26.625ZM38.25 27.5938H22.75V28.5625H38.25V27.5938ZM38.25 28.5625H22.75V29.5312H38.25V28.5625ZM38.25 29.5312H22.75V30.5H38.25V29.5312ZM38.25 30.5H22.75V31.4688H38.25V30.5ZM30.5 31.4688H22.75V32.4375H30.5V31.4688Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.375 31.4688H30.5V32.4375H34.375V31.4688Z",
    fill: "#F98F30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.25 31.4688H34.375V32.4375H38.25V31.4688ZM30.5 32.4375H22.75V33.4062H30.5V32.4375Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.312 32.4375H30.5V33.4062H36.312V32.4375Z",
    fill: "#F98F30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.25 32.4375H36.312V33.4062H38.25V32.4375ZM30.5 33.4062H22.75V34.375H30.5V33.4062Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.375 33.4062H30.5V34.375H34.375V33.4062Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.25 33.4062H34.375V34.375H38.25V33.4062ZM30.5 34.375H22.75V35.3438H30.5V34.375Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.375 34.375H30.5V35.3438H34.375V34.375Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.25 34.375H34.375V35.3438H38.25V34.375Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5 25.6562H24.688V26.625H30.5V25.6562ZM37.281 25.6562H31.469V26.625H37.281V25.6562ZM25.656 26.625H24.688V27.5938H25.656V26.625Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.594 26.625H25.656V27.5938H27.594V26.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.531 26.625H27.594V27.5938H29.531V26.625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5 26.625H29.531V27.5938H30.5V26.625ZM32.438 26.625H31.469V27.5938H32.438V26.625Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.375 26.625H32.438V27.5938H34.375V26.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.312 26.625H34.375V27.5938H36.312V26.625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.281 26.625H36.312V27.5938H37.281V26.625ZM25.656 27.5938H21.781V28.5625H25.656V27.5938Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.594 27.5938H25.656V28.5625H27.594V27.5938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.531 27.5938H27.594V28.5625H29.531V27.5938Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.438 27.5938H29.531V28.5625H32.438V27.5938Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.375 27.5938H32.438V28.5625H34.375V27.5938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.312 27.5938H34.375V28.5625H36.312V27.5938Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.281 27.5938H36.312V28.5625H37.281V27.5938ZM22.75 28.5625H21.781V29.5312H22.75V28.5625ZM25.656 28.5625H24.688V29.5312H25.656V28.5625Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.594 28.5625H25.656V29.5312H27.594V28.5625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.531 28.5625H27.594V29.5312H29.531V28.5625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5 28.5625H29.531V29.5312H30.5V28.5625ZM32.438 28.5625H31.469V29.5312H32.438V28.5625Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.375 28.5625H32.438V29.5312H34.375V28.5625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.312 28.5625H34.375V29.5312H36.312V28.5625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.281 28.5625H36.312V29.5312H37.281V28.5625ZM22.75 29.5312H21.781V30.5H22.75V29.5312ZM25.656 29.5312H24.688V30.5H25.656V29.5312Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.594 29.5312H25.656V30.5H27.594V29.5312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.531 29.5312H27.594V30.5H29.531V29.5312Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5 29.5312H29.531V30.5H30.5V29.5312ZM32.438 29.5312H31.469V30.5H32.438V29.5312Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.375 29.5312H32.438V30.5H34.375V29.5312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.312 29.5312H34.375V30.5H36.312V29.5312Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.281 29.5312H36.312V30.5H37.281V29.5312ZM30.5 30.5H24.688V31.4688H30.5V30.5ZM37.281 30.5H31.469V31.4688H37.281V30.5Z",
    fill: "#F3322C"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18.9423V7H20.385M42.5 7H54V18.5M54 41.5V53H42.5M19.5 53H8V41.5",
    stroke: "#D8BE8D",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: 0,
    y: 0,
    width: 61,
    height: 61,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.776471 0 0 0 0 0.231373 0 0 0 0 0.196078 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.f8daa865bbc14fdb012c329d611d1868.svg";
export { ForwardRef as ReactComponent };